import { render, staticRenderFns } from "./i-list.vue?vue&type=template&id=8e442c9a&scoped=true&"
import script from "./i-list.vue?vue&type=script&lang=js&"
export * from "./i-list.vue?vue&type=script&lang=js&"
import style0 from "./i-list.vue?vue&type=style&index=0&id=8e442c9a&lang=css&scoped=true&"
import style1 from "./i-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e442c9a",
  null
  
)

export default component.exports